import { Divider, Grid, Typography } from "@mui/material";
import React from "react";

export const Footer = () => {
    return (
        <>
            <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                <Grid item xs={12}>
                    <Divider />
                    <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                        <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                        Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                        La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                        <a href="https://www.cibnor.gob.mx/proteccion-datos-personales" target="_blank" rel="noreferrer" >Política de privacidad</a>
                    </Typography >
                </Grid>
            </Grid>
        </>
    );
};
